import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) => ({
  container:{
    display:"flex",
    flexDirection:"column",
    flex:2,
    minWidth: 0
  },
  text: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  header: {
    color:theme.palette.primary.main,
    marginBottom: "0 !important",
    marginTop: "0 !important",
    paddingBottom:"0 !important"
  }
}));